import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface InternalUserFormPayload {
  full_name: string;
  email: string;
  phone?: string;
  role_id: number;
  product_scope?: number[];
  notes?: string;
}

const list = (payload: { includeDeleted?: boolean } = {}) => {
  const params: Record<string, string> = {};
  if (payload.includeDeleted) params.includeDeleted = 'true';
  const query = new URLSearchParams(params).toString();
  return http.get(`${API_ENDPOINTS.internalUsers}${query ? `?${query}` : ''}`);
};

const get = (id: number | string) => http.get(`${API_ENDPOINTS.internalUsers}/${id}`);

const create = (payload: InternalUserFormPayload) => http.post(API_ENDPOINTS.internalUsers, payload);

const update = (id: number | string, payload: Partial<InternalUserFormPayload>) =>
  http.put(`${API_ENDPOINTS.internalUsers}/${id}`, payload);

const resendInvite = (id: number | string) => http.post(`${API_ENDPOINTS.internalUsers}/${id}/resend-invite`);

const deactivate = (id: number | string, reason?: string) =>
  http.patch(`${API_ENDPOINTS.internalUsers}/${id}/deactivate`, { reason });

const reactivate = (id: number | string) => http.patch(`${API_ENDPOINTS.internalUsers}/${id}/reactivate`);

const remove = (id: number | string, reason: string) =>
  http.delete(`${API_ENDPOINTS.internalUsers}/${id}`, { data: { reason } });

const activate = (token: string) => http.post(API_ENDPOINTS.activate, { token });

const InternalUserService = { list, get, create, update, resendInvite, deactivate, reactivate, remove, activate };

export default InternalUserService;
